{
  "name": "@dcl/asset-packs",
  "version": "1.2.5",
  "description": "",
  "main": "dist/definitions.js",
  "typings": "dist/definitions.d.ts",
  "scripts": {
    "download": "ts-node --project tsconfig.scripts.json ./scripts/download.ts",
    "validate": "ts-node --project tsconfig.scripts.json ./scripts/validate.ts",
    "upload": "ts-node --project tsconfig.scripts.json ./scripts/upload.ts",
    "start": "concurrently \"npm run start:js\" \"npm run start:lib\" \"npm run start:catalog\"",
    "start:js": "sdk-commands start --no-browser",
    "start:lib": "npm run build:lib -- --watch",
    "start:catalog": "nodemon --watch packs -x \"npm run build:catalog\"",
    "build:js": "sdk-commands build",
    "build:lib": "tsc --project tsconfig.lib.json",
    "build:catalog": "ts-node --project tsconfig.scripts.json ./scripts/catalog.ts",
    "build": "npm run build:js && npm run build:lib && npm run build:catalog"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/decentraland/asset-packs.git"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "bugs": {
    "url": "https://github.com/decentraland/asset-packs/issues"
  },
  "homepage": "https://github.com/decentraland/asset-packs#readme",
  "devDependencies": {
    "@aws-sdk/client-s3": "^3.405.0",
    "@aws-sdk/lib-storage": "^3.405.0",
    "@dcl/hashing": "^3.0.4",
    "@types/mime-types": "^2.1.1",
    "@types/node-fetch": "^2.6.4",
    "concurrently": "^8.2.1",
    "dotenv": "^16.3.1",
    "fp-future": "^1.0.1",
    "mime-types": "^2.1.35",
    "node-fetch": "^2.7.0",
    "nodemon": "^3.0.1",
    "p-queue": "^7.4.1",
    "prettier": "^3.0.2",
    "rimraf": "^5.0.1",
    "serve": "^14.2.1",
    "serve-handler": "^6.1.5",
    "ts-node": "^10.9.1",
    "typescript": "^5.1.6"
  },
  "dependencies": {
    "@dcl-sdk/utils": "^1.1.3",
    "@dcl/js-runtime": "7.3.18",
    "@dcl/sdk": "^7.3.18",
    "mitt": "^3.0.1"
  },
  "prettier": {
    "singleQuote": true,
    "semi": false,
    "printWidth": 80
  },
  "commit": "0f5a5eef96aa96fc65f84365d3eb00d2cb073127"
}
